import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../css/create-quiz.css";
import axios from "axios";
import { SCHOOL_QUIZ_API_BASE_URL } from "../../components/config";

import { resetQuizForm, setQuizForm, setState } from "../redux/slice";
import {
  setNewQuestionForm,
  fetchThemes,
  fetchQuizTypes,
  fetchSubjects,
  fetchSubjectBasedClassesData,
  clearSubjectBasedClasses,
} from "../../components/SchoolQuiz/redux/schoolQuizSlice";
import {
  fetchClassesThunk,
  fetchSubjectsByClassThunk,
} from "../../components/chapter/redux/chapterThunk";
import { createQuiz, imageUpload } from "../redux/thunk";
import { useNavigate } from "react-router-dom";
import { convertTermsToHtml } from "../utils";

const LevelTableCommon = ({ data = [], type }) => {
  const isAcademic = type === 1 || type === 2;
  const isThematic = type === 3 || type === 4;
  const cellStyle = {
    border: "1px solid #000",
    padding: "8px",
    fontSize: "13px",
  };
  return (
    <table
      style={{
        width: "110%",
        borderCollapse: "collapse",
        border: "1px solid #000",
      }}
    >
      <thead>
        <tr>
          {isAcademic && (
            <>
              <th style={cellStyle}>Class Name</th>
              <th style={cellStyle}>Subject Name</th>
            </>
          )}

          {isThematic && (
            <>
              <th style={cellStyle}>Parent Theme</th>
              <th style={cellStyle}>Child Theme</th>
              <th style={cellStyle}>Group Name</th>
            </>
          )}

          <th style={cellStyle}>Total Questions</th>
          <th style={cellStyle}>Basic</th>
          <th style={cellStyle}>Advanced</th>
          <th style={cellStyle}>Ultra</th>
          <th style={cellStyle}>Docmaster</th>
        </tr>
      </thead>

      <tbody>
        {data.length === 0 ? (
          <tr>
            <td
              colSpan={isAcademic ? 8 : 10}
              style={{ ...cellStyle, textAlign: "center" }}
            >
              No data available
            </td>
          </tr>
        ) : (
          data.map((item, index) => (
            <tr key={index}>
              {isAcademic && (
                <>
                  <td style={cellStyle}>{item.class_name || "-"}</td>
                  <td style={cellStyle}>{item.subject_name || "-"}</td>
                </>
              )}

              {isThematic && (
                <>
                  <td style={cellStyle}>{item.parent_theme || "-"}</td>
                  <td style={cellStyle}>{item.child_theme || "-"}</td>
                  <td style={cellStyle}>{item.group_name || "-"}</td>
                </>
              )}

              <td style={cellStyle}>{item.total ?? 0}</td>
              <td style={cellStyle}>{item.basic ?? 0}</td>
              <td style={cellStyle}>{item.advanced ?? 0}</td>
              <td style={cellStyle}>{item.ultra ?? 0}</td>
              <td style={cellStyle}>{item.docmaster ?? 0}</td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
};
export default function CreateQuiz() {
  const { quizForm, subThemes, selectedSubThemes } = useSelector(
    (state) => state.quizManagement,
  );
  const {
    themes,

    // selectedSubThemes,
    // subQuizType,
    // quizType,
    quizTypesList,
    subjectsList,
    loading,
    subjectBasedClasses,
  } = useSelector((state) => state.schoolQuiz || {});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { prizeDescription } = quizForm;
  const [state, setStatee] = useState({
    allotments: [],
    // quizType: 1,
    icon: null,
  });
  const [groups, setGroups] = useState([]);
  const [groupId, setGroupId] = useState([]);
  const [error, setError] = useState("");
  const [countInfo, setCountInfo] = useState(null);
  const [quizType, setQuizType] = useState("");
  const [subQuizType, setSubQuizType] = useState("");
  // const [classIds, setClassIds] = useState([]);
  useEffect(() => {
    dispatch(fetchClassesThunk());
    dispatch(fetchThemes());
    dispatch(fetchQuizTypes());
    fetchGroups();
    dispatch(fetchSubjects());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  useEffect(() => {
    if (quizType) {
      const defaultLevels = ["basic", "advanced", "ultra", "docmaster"];

      // add each difficulty level only if not already present
      defaultLevels.forEach((level) => {
        handleAllotmentChange(level);
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quizType]);

  useEffect(() => {
    // don't bail permanently on a transient undefined quizForm
    if (!quizType) return;

    const val = quizType === 1 ? getCompetitionTerms() : getPracticeQuizTerms();
    dispatch(setQuizForm({ key: "terms", value: val }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quizType, subQuizType]);
  // useEffect(() => {
  //   if (quizForm?.subject_id) {
  //     const subject_id = quizForm?.subject_id;
  //     dispatch(
  //       fetchSubjectBasedClassesData({
  //         subject_id,
  //       }),
  //     );
  //   }
  // }, [dispatch, quizForm?.subject_id]);
  useEffect(() => {
    const subject_id = quizForm?.subject_id;

    // Immediately remove old classes
    dispatch(clearSubjectBasedClasses());

    // Clear selected classes
    dispatch(
      setQuizForm({
        key: "class_ids",
        value: [],
      }),
    );

    if (subject_id) {
      dispatch(
        fetchSubjectBasedClassesData({
          subject_id: Number(subject_id),
        }),
      );
    }
  }, [dispatch, quizForm?.subject_id]);
  const handleChangeNew = (key, value) => {
    setStatee((prev) => ({
      ...prev,
      [key]: value,
    }));

    dispatch(resetQuizForm());
  };

  const getCount = async ({ class_ids, theme_ids, group_id }) => {
    const payload =
      subQuizType === 1 || subQuizType === 2
        ? {
            class_id: class_ids,
            subject_id: quizForm.subject_id,
          }
        : subQuizType === 3 || subQuizType === 4
          ? {
              theme_id: theme_ids,
              group_id,
            }
          : "";
    try {
      // ✅ Use the actual API endpoint string (not the same variable name)
      const res = await axios.post(
        // "https://web1024.docmaster.in:5007/api/school/quiz/admin/get-count",
        "https://web1024.docmaster.in:5007/api/school/quiz/admin/get-count",
        {
          ...payload,
          quiz_type: subQuizType,
        },
      );

      console.log("✅ API Response:", res.data);
      setCountInfo(res.data || []);
      alert(`Available Questions Count: ${res.data.total_count}`);
      return res.data;
    } catch (err) {
      console.error("❌ getAvailableQuestionsCount error:", err);
      // rejectWithValue can only be used inside createAsyncThunk, so use throw here
      throw err.response?.data || err.message;
    }
  };

  //For subject & class
  useEffect(() => {
    dispatch(fetchClassesThunk());
    dispatch(fetchThemes());
    fetchGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const fetchGroups = async () => {
    // setLoading(true);
    setError("");
    try {
      const res = await axios.get(`${SCHOOL_QUIZ_API_BASE_URL}/groups`);
      console.log("res.data", res.data);
      const data = res?.data?.data || [];
      console.log("res.dataa", data);
      setGroups(data || []);
    } catch (err) {
      setError("Failed to fetch group data");
      console.error("fetchGroups error:", err);
    } finally {
      // setLoading(false);
    }
  };

  // When a class is selected, fetch subjects for that class
  useEffect(() => {
    if (quizForm.class_id) {
      // ensure numeric id if your thunk expects it
      dispatch(fetchSubjectsByClassThunk(Number(quizForm.class_id)));
    }
  }, [quizForm.class_id, dispatch]);

  // const val1 = quizForm.totalQuestions * quizForm.questionDuration;

  function formatTerms(text) {
    if (!text) return "";

    const lines = text.split("\n").filter((l) => l.trim() !== "");

    let html = "<ol>";
    let inSubList = false;

    lines.forEach((line, idx) => {
      const trimmed = line.trim();

      // ✅ First line as heading (if it doesn’t start with a number.)
      if (idx === 0 && !/^\d+\./.test(trimmed)) {
        html = `<h3>${trimmed}</h3><ol>`;
        return;
      }

      // ✅ Main section (starts with number.)
      if (/^\d+\./.test(trimmed)) {
        if (inSubList) {
          html += "</ul>"; // close any open sublist
          inSubList = false;
        }
        // remove the leading number & dot
        const withoutNum = trimmed.replace(/^\d+\.\s*/, "");
        html += `<li><strong>${withoutNum}</strong><ul>`;
        inSubList = true;
      }
      // ✅ Sub-point
      else {
        if (inSubList) {
          html += `<li>${trimmed}</li>`;
        } else {
          html += `<p>${trimmed}</p>`;
        }
      }
    });

    if (inSubList) html += "</ul>";
    html += "</ol>";

    return html;
  }

  const getCompetitionTerms = () =>
    "*Hosting Legal*\n" +
    "Quiz is an initiative of DocMaster. It is a step aimed to empower its users with knowledge sharpening and rehearsals with current developments and increase in critical thinking around legal frameworks. Participating in DocMaster - Quiz is only subject to acceptance of its terms and conditions.\n\n" +
    "*Eligibility*\n" +
    "The quiz is open to all, it majorly focused for legal professionals, undergraduate and postgraduate law students from law colleges and universities.\n\n" +
    "*Registration*\n" +
    "Participants have to register first on the website of https://www.DocMaster.Legal as an advocate or a student which is totally free..\n" +
    "DocMaster will give option to practice on different topics.\n" +
    `While participating in a Quiz Competition every participant will have to submit its intent, where an OTP will be sent before the start of it.
There are no registration charges or fees applicable to participate in the Quiz.
Participants must complete personal information asked during registration. False, incomplete or misleading data may lead to disqualification or future problems to the participants.\n` +
    `Participants are expected to read all terms and conditions and guidelines before starting the use of DocMaster or to participate in the Quiz.  After registering, it would be treated a confirmation from the participants that they have gone through it and give acceptance of all terms and conditions of DocMaster.\n\n` +
    "*Quiz Format*\n" +
    "The quiz will be conducted only through online mode and would be available on https://www.DocMaster.Legal \n The Quiz schedule and timings will be announced from time to time at least 24 hours in advance.\nAll participants will themselves be responsible to check in advance their comfort and compatibility to participate, that is if they can execute the Quiz Process using laptop, desktop, tablet or by a mobile phone and their respective internet connection. The DocMaster can not be held responsible for any system glitches, slow internet or anything which arise from the side of the users. The DocMaster is not charging any fees or charges and offering its platform totally free.\n" +
    `The scoring system is designed to be calculated automatically upon each submission and shall be considered final at each level and step. No requests for re-evaluation or modification will be entertained as it’s a competition to learn and sharpen the skill. The quiz does not help in getting any degree or recognition. In the event of any technical disruption including connectivity issues, device failures or system glitches, the decision to permit re-attempts shall rest solely with DocMaster and will be considered at its discretion.\n` +
    "The overall results will be published on the dashboard immediately following the conclusion of the quiz. In the event of a tie, the participant who submits their responses earliest will be accorded a higher rank. The numbers, time and speed will be the essence of the quiz.\n" +
    "Our quiz system is designed to randomly assign and display different sets of questions to each participant during the same quiz session. This ensures a dynamic, fair, and secure assessment environment for all users.\n\n" +
    "*How to Play*\n" +
    `The quiz comprises a certain number of multiple-choice questions, each featuring four answer options. Participants will have [X seconds] seconds to respond to each question, with the timer beginning as soon as the question appears. Once the quiz starts, questions will be presented one at a time. To proceed, participants must select the correct option and click the "Submit" button to move to the next question. The quiz must be completed in a single uninterrupted session.\n\n` +
    "*Markings*\n" +
    "The quiz comprises [Number] objective questions (e.g., MCQs, case-based scenarios), with a total duration of [X seconds] seconds ([X second] seconds per question).\n\n" +
    "*Scoring, Feedback & Result Declaration*\n" +
    `Performance in the quiz will be evaluated based on “Maximum Correct Answers in the Shortest Time”, determined electronically. Thus, in case of a tie(s), the participant who completed the Quiz at the earliest shall be considered the best performer.
Each correct answer awards [Correct]
Scores are auto-generated upon submission and are final. The correct answer will be displayed after every attempt made by the user .In case of any technical failure, permitting reattempts will be the sole discretion of the DocMaster.
Overall Results will be declared on https://www.DocMaster.Legal  once the quiz duration is over.
` +
    `The quiz will cover legal domains, including and not limited to:
The upcoming quiz will cover a wide range of Indian laws, some of are listed here for your information but the question may also be raised from the acts and laws not mentioned here. These may include Constitutional Law, Civil Law, Family Law, Hindu Law, Company Law, Banking Law, Contract Law, Law of Torts, Law of Property, Law of Taxation, Insurance Law & Accidental Claims, Labour & Industrial Law, Consumer Protection, Arbitration, Conciliation & ADR, Environmental Law, Information Technology & Cyber Law, Intellectual Property Law, Land Law, Law relating to RTI, Law relating to Women & Child, Changes & Reforms, Professional Ethics, Jurisprudence, Indian Judicial System, Law and Media, Drafting of Pleading and Conveyancing and Legal English.\n` +
    "It will also include the newly introduced criminal law codes—the Bhartiya Nyaya Sanhita (BNS), Bhartiya Nagarik Suraksha Sanhita (BNSS) and Bhartiya Sakshya Adhiniyam (BSA) which have replaced the Indian Penal Code (IPC), the Code of Criminal Procedure (CrPC) and the Indian Evidence Act, respectively. This quiz will also test understanding of legal terminology and landmark judgments that have shaped Indian jurisprudence. In addition, a section will focus on features of https://www.DocMaster.legal.\n\n" +
    `*Conduct & Integrity*\n
Participants must maintain academic integrity and refrain from using unfair means, including but not limited to:` +
    "\n1.External assistance or collaboration\n 2. Use of multiple devices or accounts\n 3. Impersonation or proxy participation\n\n" +
    "Any violation will result in immediate disqualification and may be reported to the concerned institution. DocMaster reserves the right to monitor quiz activity and verify participant identity\n\n" +
    "*Data Usage & Privacy*\n" +
    "By registering, participants consent to the collection and use of their personal data for quiz administration, result processing and outreach communication. DocMaster will handle all data in accordance with its Privacy Policy, ensuring confidentiality and responsible usage. Participant data will not be sold or shared externally without informed consent, unless legally mandated.\n\n" +
    "*Legal Disclaimer*\n" +
    "Participation in the quiz constitutes a voluntary educational engagement and does not confer any legal rights, professional certification or institutional affiliation unless expressly stated by DocMaster.\n" +
    "DocMaster and its organisers shall not be held liable for any technical disruptions, personal inconveniences or academic consequences arising from participation in the quiz. Participation is voluntary, and users accept all risks associated with digital engagement.\n" +
    "Any disputes or claims related to the quiz shall be governed by the applicable laws of India and subject to the exclusive jurisdiction of the courts situated in Delhi.\n\n" +
    "*Grievance and Redressal*\n" +
    "All grievances or concerns must be formally submitted in writing to info@DocMaster.in within three days following the conclusion of the quiz. The organising committee will endeavour to review and respond within fifteen working days. All decisions made in this regard shall be final and binding.\n\n" +
    "*Amendments*\n" +
    "DocMaster solely reserves the right to revise the quiz format, schedule, content or associated terms at its discretion. Any such modifications will be duly communicated through the official website. Continued engagement with the quiz following these updates shall constitute deemed acceptance of the amended terms.\n\n" +
    "*Contact*\n" +
    `For queries, technical support or clarifications, please reach out to:
Email: info@DocMaster.in
Call us at +91 9289 44 0048
Website: https://www.DocMaster.Legal`;

  const getPracticeQuizTerms = () =>
    "1. All registered users including law students, legal interns, educators, and professionals are eligible to access practice quizzes.\n" +
    `2. This is a timed quiz with [Number] questions to be answered in [X seconds] seconds ([X second] seconds per question) but it is non-competitive.\n` +
    "3. They are designed for self-paced learning and concept reinforcement.\n" +
    "4. Scores are for personal tracking only and do not affect rankings or certification.\n" +
    "5. To Participate, user needs to register on the website.\n" +
    "6. The participants will be required to provide their name, email address, telephone number etc. By submitting the contact details, participants consent that the contact information can be used for the quiz.\n" +
    "7. The quiz will start as soon as the participant clicks the “Start Quiz” button.\n" +
    "8. Once submitted, an entry cannot be withdrawn.\n" +
    "9. A participant can participate multiple times in a practice quiz.\n" +
    "10. Topics may include Contract Law, Criminal Procedure, Environmental Law, Constitutional Law, Legal Drafting, and more.\n" +
    "11. The participant will abide by all the rules and regulations of participating in the quiz.\n" +
    "12. Quiz content is reviewed periodically to reflect changes in law, pedagogy, and user feedback.\n" +
    "13. While every effort is made to ensure accuracy, users are advised to cross-reference with official statutes, case law, and academic resources for formal study or examination.\n" +
    "14. Scores and progress may be tracked for personal use.\n" +
    "15. Practice quizzes do not contribute to rankings, certifications, or rewards unless explicitly stated.\n" +
    "16. Data may be used anonymously to improve platform recommendations and learning analytics.\n" +
    "17. No personal data is shared with third parties without consent.\n" +
    "18. Users must maintain academic integrity while using the platform. Any attempt to manipulate scores, impersonate users, or misuse content may result in restricted access or account suspension.\n" +
    "19. DocMaster.Legal is not liable for any academic, professional, or legal outcomes resulting from quiz use.\n" +
    "20. Practice quizzes are supplementary tools and do not replace formal legal education or professional advice.\n" +
    "21. By entering the quiz, the participant accepts and agrees to the terms and conditions mentioned above." +
    "*Scoring, Feedback & Result Declaration*\n" +
    "Performance in the quiz will be evaluated based on “Maximum Correct Answers in the Shortest Time”, determined electronically. Thus, in case of a tie(s), the participant who completed the Quiz at the earliest shall be considered the best performer." +
    "Each correct answer awards [Correct]\n" +
    `Scores are auto-generated upon submission and are final.
The correct answer will be displayed after every attempt made by the user
In case of any technical failure, permitting reattempts will be the sole discretion of the DocMaster.\n` +
    "Overall Results will be declared on https://www.DocMaster.Legal  once the quiz duration is over.\n" +
    `The quiz will cover legal domains, including and not limited to:
The upcoming quiz will cover a wide range of Indian laws, some of are listed here for your information but the question may also be raised from the acts and laws not mentioned here. These may include Constitutional Law, Civil Law, Family Law, Hindu Law, Company Law, Banking Law, Contract Law, Law of Torts, Law of Property, Law of Taxation, Insurance Law & Accidental Claims, Labour & Industrial Law, Consumer Protection, Arbitration, Conciliation & ADR, Environmental Law, Information Technology & Cyber Law, Intellectual Property Law, Land Law, Law relating to RTI, Law relating to Women & Child, Changes & Reforms, Professional Ethics, Jurisprudence, Indian Judicial System, Law and Media, Drafting of Pleading and Conveyancing and Legal English.
\n` +
    "It will also include the newly introduced criminal law codes—the Bhartiya Nyaya Sanhita (BNS), Bhartiya Nagarik Suraksha Sanhita (BNSS) and Bhartiya Sakshya Adhiniyam (BSA) which have replaced the Indian Penal Code (IPC), the Code of Criminal Procedure (CrPC) and the Indian Evidence Act, respectively. This quiz will also test understanding of legal terminology and landmark judgments that have shaped Indian jurisprudence. In addition, a section will focus on features of https://www.DocMaster.legal." +
    "";

  const handleChange = (key, value) => {
    dispatch(setQuizForm({ key, value }));
  };

  useEffect(() => {
    if (quizForm.theme_id) {
      const filtered =
        themes.find((e) => e.theme_id === Number(quizForm.theme_id))
          ?.sub_theme || [];
      dispatch(
        setState({
          key: "subThemes",
          value: filtered,
        }),
      );
    }
  }, [quizForm.theme_id]);

  // Handle winner prize change

  const removeAllotment = (difficulty_level) => {
    setStatee((prev) => ({
      ...prev,
      allotments: prev.allotments.filter(
        (a) => a.difficulty_level !== difficulty_level,
      ),
    }));
  };
  // Add allotment for a difficulty level if not present
  const handleAllotmentChange = (difficulty_level) => {
    if (
      !state.allotments.some(
        (item) => item.difficulty_level === difficulty_level,
      )
    ) {
      setStatee((prev) => ({
        ...prev,
        allotments: [...prev.allotments, { difficulty_level, percentage: "" }],
      }));
    }
  };

  const updatePercent = (index, value) => {
    const updated = [...state.allotments];
    updated[index].percentage = value;
    setStatee((prev) => ({ ...prev, allotments: updated }));
  };
  const userStr = localStorage.getItem("user");
  const userId = userStr
    ? JSON.parse(userStr).id
    : JSON.parse(userStr).user_id
      ? userStr?.user_id
      : "";
  // const userId = JSON.parse(localStorage.getItem("user"))?.id;

  // =========================================================================
  // ✅ NEW: Centralized form validation based on quiz type / sub quiz type.
  // This does NOT touch the payload/body construction logic in handleSubmit.
  // It simply returns an error message string if something is invalid, or
  // null if the form is good to submit.
  // =========================================================================
  const validateQuizForm = () => {
    const errors = [];

    // ---- Quiz Type & Sub Quiz Type (top of form) ----
    if (!quizType) {
      errors.push("Quiz Type (Live/Practice)");
    }
    if (!subQuizType) {
      errors.push("Sub Quiz Type");
    }

    // If quiz type / sub quiz type itself isn't chosen yet, no point checking
    // the rest of the form (it isn't even rendered), so stop here.
    if (!quizType || !subQuizType) {
      return errors.join(", ");
    }

    // ---- Quiz Title ----
    if (!quizForm.title?.trim()) {
      errors.push("Quiz Title");
    }

    // ---- Live quiz: Registration Details, then Question Details (form order) ----
    if (quizType === 1) {
      if (!quizForm.registrationStart) {
        errors.push("Registration Start Date");
      }
      if (!quizForm.registrationEnd) {
        errors.push("Registration End Date");
      }
      if (!quizForm.start) {
        errors.push("Quiz Start Date");
      }

      if (
        quizForm.registrationStart &&
        quizForm.registrationEnd &&
        quizForm.start
      ) {
        const now = Date.now();
        const regStart = Date.parse(quizForm.registrationStart);
        const regEnd = Date.parse(quizForm.registrationEnd);
        const startDate = Date.parse(quizForm.start);

        if (isNaN(regStart) || isNaN(regEnd) || isNaN(startDate)) {
          errors.push("Valid Registration/Quiz Dates");
        } else {
          if (regStart <= now) {
            errors.push("Registration Start Date (must be in the future)");
          }
          if (regEnd <= regStart) {
            errors.push("Registration End Date (must be after start date)");
          }
          if (startDate <= regEnd) {
            errors.push(
              "Quiz Start Date (must be after registration end date)",
            );
          }
        }
      }

      if (!quizForm.registrationFeeMode) {
        errors.push("Registration Fee Mode (Free/Paid)");
      }
      if (
        quizForm.registrationFeeMode === "paid" &&
        (!quizForm.registrationCost || Number(quizForm.registrationCost) <= 0)
      ) {
        errors.push("Registration Cost");
      }

      // Question Details (Total Questions, Duration per Qn)
      if (
        !Number(quizForm.totalQuestions) ||
        Number(quizForm.totalQuestions) <= 0
      ) {
        errors.push("Total Question(s)");
      }
      if (
        !Number(quizForm.questionDuration) ||
        Number(quizForm.questionDuration) <= 0
      ) {
        errors.push("Duration per Question");
      }
      if (
        countInfo &&
        Number(quizForm.totalQuestions) > Number(countInfo?.total_count)
      ) {
        errors.push(
          `Total Questions (must not exceed ${countInfo?.total_count})`,
        );
      }
    }

    // ---- Practice quiz: Icon, then Question fields (form order) ----
    if (quizType === 2) {
      if (!state.icon) {
        errors.push("Icon for the Quiz");
      }
      if (
        !Number(quizForm.totalQuestions) ||
        Number(quizForm.totalQuestions) <= 0
      ) {
        errors.push("Total Question(s)");
      }
      if (
        !Number(quizForm.questionDuration) ||
        Number(quizForm.questionDuration) <= 0
      ) {
        errors.push("Question Duration");
      }
      if (
        countInfo &&
        Number(quizForm.totalQuestions) > Number(countInfo?.total_count)
      ) {
        errors.push(
          `Total Questions (must not exceed ${countInfo?.total_count})`,
        );
      }
    }

    // ---- Marks (shown next, for both quiz types) ----
    if (
      quizForm.correct === "" ||
      quizForm.correct === undefined ||
      Number(quizForm.correct) <= 0
    ) {
      errors.push("Marks For Correct Answer");
    }
    if (
      quizForm.enableWrongMarks &&
      (quizForm.wrong === "" ||
        quizForm.wrong === undefined ||
        quizForm.wrong === null)
    ) {
      errors.push("Negative Marks For Wrong Answer");
    }
    if (
      quizForm.enableSkippedMarks &&
      (quizForm.skipped === "" ||
        quizForm.skipped === undefined ||
        quizForm.skipped === null)
    ) {
      errors.push("Negative Marks For Skipped Answer");
    }

    // ---- Subject & Class selection (subQuizType 1 or 2) — shown next ----
    if (subQuizType === 1 || subQuizType === 2) {
      if (!quizForm.subject_id) {
        errors.push("Subject");
      }
      if (
        !Array.isArray(quizForm.class_ids) ||
        quizForm.class_ids.length === 0
      ) {
        errors.push("Class(es)");
      }
    }

    // ---- Theme & Group selection (subQuizType 3 or 4) — shown next ----
    if (subQuizType === 3 || subQuizType === 4) {
      if (!quizForm.theme_id) {
        errors.push("Theme");
      }
      if (!groupId || groupId.length === 0) {
        errors.push("Group");
      }
    }

    // ---- Question Allotment Form (Live quiz only) — shown next ----
    if (quizType === 1) {
      const totalPercentage = state.allotments.reduce(
        (sum, a) => sum + Number(a.percentage || 0),
        0,
      );
      if (totalPercentage !== 100) {
        errors.push("Difficulty Allotments (must total exactly 100%)");
      }
      if (state.allotments.some((a) => Number(a.percentage) < 0)) {
        errors.push("Difficulty Allotments (cannot be negative)");
      }
    }

    // ---- Winner Prize Details (Live quiz only) — shown next ----
    if (quizType === 1 && !prizeDescription) {
      errors.push("Winner Prize Details");
    }

    // ---- About Quiz — shown next ----
    if (!quizForm.about?.trim()) {
      errors.push("About Quiz");
    }

    // ---- Terms and Conditions — shown last ----
    if (!quizForm.terms?.trim()) {
      errors.push("Terms and Conditions");
    }

    return errors.length > 0 ? errors.join(", ") : null;
  };

  const handleSubmit = async () => {
    // ✅ NEW: run centralized validation first, based on quiz type.
    const validationError = validateQuizForm();
    if (validationError) {
      alert(`Please fill/fix the following: ${validationError}`);
      return;
    }

    const isPracticeQuiz = quizType === 2;
    const isLiveQuiz = quizType === 1;

    // ✅ Common validation
    const isCommonValid =
      quizForm.title?.trim() &&
      quizForm.start &&
      Number(quizForm.totalQuestions) > 0 &&
      Number(quizForm.questionDuration) > 0 &&
      quizForm.about?.trim() &&
      quizForm.terms?.trim() &&
      subQuizType;

    if (
      countInfo &&
      Number(quizForm.totalQuestions) > Number(countInfo?.total_count)
    ) {
      alert(`Maximum questions should be ${countInfo?.total_count}`);
      return;
    }
    if (
      isLiveQuiz &&
      state.allotments.reduce(
        (sum, a) => sum + Number(a.percentage || 0),
        0,
      ) !== 100
    ) {
      alert("Total percentage of difficulty allotments must be exactly 100%");
      return;
    }

    // ✅ Date validations
    const now = Date.now();
    const regStart = Date.parse(quizForm.registrationStart);
    const regEnd = Date.parse(quizForm.registrationEnd);
    const startDate = Date.parse(quizForm.start);

    if (isLiveQuiz) {
      if (regStart <= now) {
        alert("Registration start date must be in the future.");
        return;
      }
      if (regEnd <= regStart) {
        alert("Registration end date must be after registration start date.");
        return;
      }
      if (startDate <= regEnd) {
        alert("Start date of quiz must be after registration end date.");
        return;
      }
    }

    if (quizType === 2 && !state.icon) {
      alert("please uplaod the icon for the practice quiz");
    } // ✅ Common body
    else {
      const commonBody = {
        title: quizForm.title,
        total_questions: Number(quizForm.totalQuestions),
        duration_per_question: Number(quizForm.questionDuration),
        marks_per_question: Number(quizForm.correct),
        negative_marks_wrong: Number(quizForm.wrong),
        negative_marks_skipped: Number(quizForm.skipped),
        about_quiz: quizForm.about,
        quiz_terms: quizForm.terms,
        quiz_type: Number(subQuizType),
        created_by: userId,
        // description: quizForm.description,
      };

      // ✅ Specific body per quiz type
      const body = isLiveQuiz
        ? {
            ...commonBody,
            allotments: state.allotments.filter(
              (a) => Number(a.percentage) > 0,
            ),
            registration_start_date: quizForm.registrationStart,
            registration_end_date: quizForm.registrationEnd,
            registration_fee:
              quizForm.registrationFeeMode === "free"
                ? 0
                : parseFloat(quizForm.registrationCost).toFixed(2),
            prizes: prizeDescription,
            start_date: quizForm.start,
            registration_type: quizForm.registrationFeeMode,

            ...(subQuizType === 1
              ? {
                  subject_id: quizForm.subject_id
                    ? Number(quizForm.subject_id)
                    : null,
                  class_id: quizForm.class_ids ? quizForm.class_ids : null,
                }
              : subQuizType === 3
                ? {
                    group_id: groupId,
                    theme_id: quizForm.theme_id
                      ? selectedSubThemes?.length
                        ? selectedSubThemes
                        : [quizForm.theme_id]
                      : [],
                  }
                : {}),
          }
        : isPracticeQuiz
          ? {
              ...commonBody,
              ...(subQuizType === 2
                ? {
                    subject_id: quizForm.subject_id
                      ? Number(quizForm.subject_id)
                      : null,
                    class_id: quizForm.class_ids ? quizForm.class_ids : null,
                  }
                : subQuizType === 4
                  ? {
                      group_id: groupId,
                      theme_id: quizForm.theme_id
                        ? selectedSubThemes?.length
                          ? selectedSubThemes
                          : [quizForm.theme_id]
                        : [],
                    }
                  : {}),
            }
          : {
              ...commonBody, // fallback
            };

      console.log("BOdy to snd", body);
      // debugger;
      // ✅ API call
      if (window.confirm("Are you sure to create quiz")) {
        try {
          const res = await dispatch(createQuiz(body));
          console.log(res);
          if (quizType === 2) {
            const res2 = await dispatch(
              imageUpload({
                image: state.icon,
                id: res?.payload?.quiz_id,
                quiz_type: subQuizType,
              }),
            );
            if (res2) {
              console.log(res2);
              alert(res2?.payload?.message || "image uploaded!");
            }
          }

          if (res) {
            if (res?.payload?.message === "Missing required fields") {
              // window.location.reload();
              alert(res?.payload?.message);
              navigate("/dashboard/create-school-quiz");
            } else {
              alert(res?.payload?.message || "Quiz created successfully");
              setStatee({ allotments: [] });
              dispatch(resetQuizForm());
              navigate("/dashboard/view-or-update-school-quizzes"); // window.location.reload();
            }
          }
        } catch (err) {
          console.error("Error creating quiz:", err);
          alert("Error creating quiz");
        }
      }
    }
  };

  const totalAllotment =
    quizType === 1
      ? state.allotments.reduce((sum, a) => sum + Number(a.percentage || 0), 0)
      : 0;

  // const filteredList =
  //   quizType !== null && quizType === 1
  //     ? quizTypesList?.data.filter((e) => e.is_live === 1)
  //     : quizType === 2
  //       ? quizTypesList?.data?.filter((e) => e.is_live === 0)
  //       : [];

  const filteredList =
    quizType === 1
      ? (quizTypesList?.data?.filter((e) => e.is_live === 1) ?? [])
      : quizType === 2
        ? (quizTypesList?.data?.filter((e) => e.is_live === 0) ?? [])
        : [];
  function handleClearSubjectNTheme() {
    dispatch(setNewQuestionForm({ key: "theme_id", value: "" }));
    setCountInfo(null);
    handleChange("subject_id", "");
    setGroupId([]);

    dispatch(
      setQuizForm({
        key: "class_ids",
        value: [],
      }),
    );
  }
  return (
    <div className="container-fluid w-100 mx-auto py-2 font-inter">
      <div className="row mx-auto w-100">
        <div className="col-md-12 w-100">
          <h3 className="text-3xl font-bold text-center mb-6 text-gray-800">
            Create Quiz
          </h3>
          <div
            className="bg-white mb-8 max-w-4xl mx-auto shadow rounded-3 p-4"
            style={{ height: "70vh", overflow: "auto" }}
          >
            <div className="row mb-3">
              <label className="col-sm-4 col-form-label font-medium text-gray-700">
                Quiz Type
              </label>
              {/* quiz type selection */}
              <div className="col-sm-8 d-flex align-items-center gap-3">
                {[
                  { label: "Live", value: 1 },
                  { label: "Practice", value: 2 },
                ].map((option) => (
                  <label
                    key={option.value}
                    className="form-check-label d-flex align-items-center gap-2"
                  >
                    <input
                      type="radio"
                      className="form-check-input"
                      name="quizType"
                      value={option.value}
                      checked={Number(quizType) === option.value}
                      onChange={(e) => {
                        // store as number to avoid type-mismatch later
                        const val = Number(e.target.value);
                        setQuizType(val);
                        setSubQuizType("");
                        dispatch(resetQuizForm());
                        handleClearSubjectNTheme();
                        setState({
                          allotments: [],
                          icon: null,
                        });
                      }}
                      disabled={loading}
                    />
                    {option.label}
                  </label>
                ))}
              </div>
              {/* sub quiz type selection */}
              {quizType !== null && (
                <>
                  {quizType && (
                    <label className="col-sm-4 col-form-label font-medium text-gray-700">
                      Sub Quiz Type
                    </label>
                  )}
                  <div className="col-sm-8 d-flex align-items-center gap-3 flex-wrap">
                    {filteredList.map((quiz) => (
                      <label
                        key={quiz.id}
                        className="form-check-label d-flex align-items-center gap-2"
                      >
                        <input
                          type="radio"
                          className="form-check-input"
                          name="subQuizType"
                          value={quiz.id}
                          checked={subQuizType === quiz.id} // == handles string vs number
                          onChange={(e) => {
                            setSubQuizType(Number(e.target.value));
                            dispatch(resetQuizForm());
                            handleClearSubjectNTheme();
                            setState({
                              allotments: [],
                              icon: null,
                            });
                          }}
                          disabled={loading}
                        />

                        {quiz.type.charAt(0).toUpperCase() + quiz.type.slice(1)}
                      </label>
                    ))}
                  </div>
                </>
              )}
            </div>
            {quizType !== "" ? (
              <>
                <div
                  style={{
                    display: "flex",
                    gap: "4%",
                    flexDirection: "row",
                    marginBottom: "2%",
                  }}
                >
                  <label style={{ fontWeight: 545 }}>Quiz Title</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className=" form-control"
                      placeholder="Enter quiz title"
                      value={quizForm.title}
                      onChange={(e) => handleChange("title", e.target.value)}
                      required
                      maxLength={30}
                    />
                    <span>{quizForm?.title.length}/30</span>
                  </div>
                </div>
                {quizType === 1 && (
                  <h3 style={{ textAlign: "center", fontSize: "18px" }}>
                    Registration Details{" "}
                  </h3>
                )}{" "}
                {quizType === 1 ? (
                  <div>
                    <div style={{ display: "flex", gap: "2%" }}>
                      {["registrationStart", "registrationEnd", "start"].map(
                        (key, idx) => (
                          <div className="form-group" key={key}>
                            <label
                              className="form-label"
                              style={{ fontWeight: 545 }}
                            >
                              {
                                [
                                  "Registration Quiz Start Date",
                                  "Registration Quiz End Date",
                                  "Quiz Date",
                                ][idx]
                              }
                            </label>
                            <input
                              type="datetime-local"
                              className="form-input"
                              value={quizForm[key]}
                              onChange={(e) =>
                                handleChange(key, e.target.value)
                              }
                              required
                            />
                          </div>
                        ),
                      )}
                    </div>
                    <div style={{ display: "flex", gap: "5%" }}>
                      <div className="form-group mb-4">
                        <label
                          style={{ fontWeight: 545 }}
                          className="form-label block font-medium mb-2"
                        >
                          Registration Fee
                        </label>
                        <div
                          className="flex items-center gap-6"
                          style={{ display: "flex", gap: "2%" }}
                        >
                          {["free", "paid"].map((mode) => (
                            <label
                              className="inline-flex items-center"
                              style={{ fontWeight: 545 }}
                              key={mode}
                            >
                              <input
                                type="radio"
                                name="registrationFeeMode"
                                value={mode}
                                checked={quizForm.registrationFeeMode === mode}
                                onChange={(e) =>
                                  handleChange(
                                    "registrationFeeMode",
                                    e.target.value,
                                  )
                                }
                                className="form-radio text-blue-600"
                                required
                              />
                              <span className="ml-2 capitalize">{mode}</span>
                            </label>
                          ))}
                        </div>
                        {quizForm.registrationFeeMode === "paid" && (
                          <div className="flex items-center gap-6 mt-2">
                            <label
                              className="inline-flex items-center"
                              style={{ fontWeight: 545 }}
                            >
                              Registration Cost
                              <input
                                type="number"
                                value={quizForm.registrationCost}
                                onChange={(e) =>
                                  handleChange(
                                    "registrationCost",
                                    e.target.value,
                                  )
                                }
                                className="form-input"
                                required
                                min="1"
                              />
                            </label>
                          </div>
                        )}
                      </div>
                    </div>
                    {quizType === 1 && (
                      <h3 style={{ textAlign: "center", fontSize: "18px" }}>
                        Question Details{" "}
                      </h3>
                    )}{" "}
                    <div style={{ display: "flex", gap: "2%" }}>
                      {[
                        { key: "totalQuestions", label: "Total Question(s)" },
                        {
                          key: "questionDuration",
                          label: "Duration per Qn (in seconds)",
                        },
                        {
                          key: "totalDuration",
                          label: "Total Duration (in seconds)",
                        },
                      ].map(({ key, label }) => (
                        <div className="form-group" key={key}>
                          <label
                            className="form-label"
                            style={{ fontWeight: 545 }}
                          >
                            {label}{" "}
                          </label>
                          <input
                            type="number"
                            disabled={key === "totalDuration"}
                            min={1}
                            style={{ width: "50%" }}
                            className="form-input"
                            // title={
                            //   label === "Duration per Qn" && " (in seconds)"
                            // }
                            value={
                              key !== "totalDuration"
                                ? quizForm[key]
                                : `${
                                    quizForm.questionDuration *
                                    quizForm.totalQuestions
                                  }`
                            }
                            onChange={(e) =>
                              handleChange(key, Number(e.target.value))
                            }
                            required
                          />
                          {key === "totalQuestions" && countInfo && (
                            <div>
                              <p style={{ color: "red" }}>
                                Available Questions Count-{" "}
                                {countInfo?.total_count}
                              </p>
                              <p>
                                {" "}
                                Level - question count
                                {JSON.stringify(countInfo.level_counts)
                                  ?.length > 0 && (
                                  <LevelTableCommon
                                    data={countInfo.level_counts}
                                    type={subQuizType}
                                  />
                                )}
                              </p>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                ) : quizType === 2 ? (
                  <div style={{ display: "flex", gap: "2%" }}>
                    <div className="form-group">
                      <label className="form-label" style={{ fontWeight: 545 }}>
                        Icon for the Quiz
                      </label>
                      <input
                        type="file"
                        accept="image/*" // ✅ only allow images (icons)
                        onChange={(e) =>
                          setStatee((prev) => ({
                            ...prev,
                            icon: e.target.files[0], // ✅ store the uploaded file
                          }))
                        }
                      />
                    </div>
                    {[
                      { key: "totalQuestions", label: "Total Question(s)" },
                      {
                        key: "questionDuration",
                        label: "Question Duration (in seconds)",
                      },
                    ].map(({ key, label }) => (
                      <div className="form-group" key={key}>
                        <label
                          className="form-label"
                          style={{ fontWeight: 545 }}
                        >
                          {label}
                        </label>
                        <input
                          type="number"
                          className="form-input"
                          value={quizForm[key]}
                          onChange={(e) =>
                            handleChange(key, Number(e.target.value))
                          }
                          required
                        />
                        {key === "totalQuestions" && countInfo && (
                          <div>
                            <p style={{ color: "red" }}>
                              Available Questions Count-{" "}
                              {countInfo?.total_count}
                            </p>
                            <p>
                              {" "}
                              Level - question count
                              {JSON.stringify(countInfo.level_counts)?.length >
                                0 && (
                                <LevelTableCommon
                                  data={countInfo.level_counts}
                                  type={subQuizType}
                                />
                              )}
                            </p>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <></>
                )}
                {/* Marks */}
                {quizType && (
                  <div style={{ display: "flex", gap: "5%" }}>
                    <div className="form-group">
                      <label className="form-label" style={{ fontWeight: 545 }}>
                        Marks For Correct Answer
                      </label>
                      <input
                        type="number"
                        className="form-input form-control"
                        value={quizForm.correct}
                        onChange={(e) =>
                          handleChange("correct", e.target.value)
                        }
                        required
                        min="1"
                      />
                    </div>

                    {[
                      {
                        key: "enableWrongMarks",
                        label: "Negative Marking For Wrong Answer",
                        inputKey: "wrong",
                      },
                      {
                        key: "enableSkippedMarks",
                        label: "Negative Marking For Skipped Answer",
                        inputKey: "skipped",
                      },
                    ].map(({ key, label, inputKey }) => (
                      <div className="form-group" key={key}>
                        <label
                          className="form-label"
                          style={{ fontWeight: 545 }}
                        >
                          <input
                            type="checkbox"
                            checked={quizForm[key]}
                            onChange={(e) =>
                              handleChange(key, e.target.checked)
                            }
                          />{" "}
                          {label}
                        </label>
                        {quizForm[key] && (
                          <input
                            type="number"
                            className="form-input"
                            placeholder={`Marks for ${inputKey}`}
                            value={quizForm[inputKey]}
                            min="0"
                            onChange={(e) =>
                              handleChange(inputKey, e.target.value)
                            }
                          />
                        )}
                      </div>
                    ))}
                  </div>
                )}
                {/* Registration Fee */}
                {/* Allotments */}
                <div>
                  <br />
                  {(subQuizType === 1 || subQuizType === 2) && (
                    <div>
                      <div className="row mb-3">
                        <h3 style={{ textAlign: "center", fontSize: "18px" }}>
                          Subject and Class(es) selection{" "}
                        </h3>
                        <label className="col-sm-4 col-form-label font-medium text-gray-700">
                          Select Subject
                        </label>
                        <div className="col-sm-8">
                          <select
                            className="form-control"
                            name="subject_id"
                            value={quizForm?.subject_id || ""}
                            onChange={(e) =>
                              handleChange("subject_id", e.target.value)
                            }
                            // disabled={loading || !newQuestionForm?.class_id}
                          >
                            <option value="">-- Select Subject --</option>
                            {(subjectsList?.data || []).map((s) => (
                              <option key={s.subject_id} value={s.subject_id}>
                                {s.subject_name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {quizForm.subject_id && (
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label font-medium text-gray-700">
                            Select Class
                          </label>

                          {subjectBasedClasses?.length === 0 && (
                            <p style={{ color: "red" }}>
                              No classes found for the selected subject
                            </p>
                          )}
                          <div className="col-sm-8 d-flex flex-wrap gap-3">
                            {(subjectBasedClasses?.data || []).map((cls) => (
                              <label
                                key={cls.class_id}
                                className="form-check-label d-flex align-items-center gap-2"
                              >
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  name="class_ids"
                                  value={cls.class_id}
                                  checked={
                                    Array.isArray(quizForm?.class_ids) &&
                                    quizForm.class_ids.includes(cls.class_id)
                                  }
                                  onChange={(e) => {
                                    const checked = e.target.checked;
                                    const classId = cls.class_id;

                                    // get current array (default empty)
                                    const currentIds = Array.isArray(
                                      quizForm?.class_ids,
                                    )
                                      ? [...quizForm.class_ids]
                                      : [];

                                    let updatedIds;
                                    if (checked) {
                                      // add class_id
                                      updatedIds = [...currentIds, classId];
                                    } else {
                                      // remove class_id
                                      updatedIds = currentIds.filter(
                                        (id) => id !== classId,
                                      );
                                    }

                                    // dispatch updated array
                                    // setClassIds(updatedIds);
                                    dispatch(
                                      setQuizForm({
                                        key: "class_ids",
                                        value: updatedIds,
                                      }),
                                    );
                                    if (updatedIds.length > 0) {
                                      getCount({
                                        class_ids: updatedIds,
                                        theme_ids: [],
                                        group_id: "",
                                      });
                                    }
                                  }}
                                  disabled={loading || !quizForm?.subject_id}
                                />
                                {cls.class_name}
                              </label>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                {quizType !== null && (
                  <>
                    <>
                      <br />
                      {/* Allotments */}
                      {(subQuizType === 3 || subQuizType === 4) && (
                        <div>
                          <h3 style={{ textAlign: "center", fontSize: "18px" }}>
                            Theme, Group Selection
                          </h3>
                          <div style={{ marginTop: "2%" }}>
                            <div className="row mb-3">
                              <div className="row">
                                <label className="col-sm-3 col-form-label font-medium text-gray-700">
                                  Theme
                                </label>
                                <div className="col-sm-9">
                                  <select
                                    className="form-control"
                                    value={quizForm.theme_id || ""}
                                    onChange={(e) => {
                                      const { value } = e.target;
                                      dispatch(
                                        setState({
                                          key: "selectedSubThemes",
                                          value: [],
                                        }),
                                      );
                                      if (groupId?.length > 0) {
                                        getCount({
                                          class_ids: [],
                                          // theme_ids: quizForm.theme_id
                                          //   ? selectedSubThemes?.length > 0
                                          //     ? selectedSubThemes
                                          //     : [quizForm.theme_id]
                                          //   : [],
                                          theme_ids: value
                                            ? selectedSubThemes?.length > 0
                                              ? selectedSubThemes
                                              : [value]
                                            : [],
                                          group_id: groupId,
                                        });
                                      }

                                      handleChange("theme_id", value);
                                    }}
                                  >
                                    <option value="">-- Select Theme --</option>
                                    {themes.map((t) => {
                                      const id = t.theme_id ?? t.id;
                                      const label =
                                        t.name ?? t.title ?? `Theme ${id}`;
                                      return (
                                        <option key={id} value={id}>
                                          {label}
                                        </option>
                                      );
                                    })}
                                  </select>
                                </div>
                              </div>
                            </div>
                            {quizForm.theme_id && subThemes?.length > 0 && (
                              <div className="row mb-3">
                                <label className="col-sm-3 col-form-label font-medium text-gray-700">
                                  <strong>Sub Themes</strong>
                                </label>

                                <div
                                  className="col-sm-9"
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    alignItems: "center",
                                    gap: "10px 20px",
                                  }}
                                >
                                  {subThemes.map((e) => {
                                    const selected = selectedSubThemes || [];
                                    const themeId = Number(e.theme_id);

                                    return (
                                      <label
                                        key={e.theme_id}
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: "6px",
                                          margin: 0,
                                          cursor: "pointer",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          value={themeId}
                                          checked={selected.some(
                                            (id) => Number(id) === themeId,
                                          )}
                                          onChange={(event) => {
                                            const isChecked =
                                              event.target.checked;

                                            const updatedList = isChecked
                                              ? [...selected, themeId]
                                              : selected.filter(
                                                  (id) =>
                                                    Number(id) !== themeId,
                                                );

                                            dispatch(
                                              setState({
                                                key: "selectedSubThemes",
                                                value: updatedList,
                                              }),
                                            );

                                            if (groupId?.length > 0) {
                                              getCount({
                                                class_ids: [],
                                                theme_ids: updatedList,
                                                group_id: groupId,
                                              });
                                            }
                                          }}
                                          className="form-check-input"
                                          style={{
                                            margin: 0,
                                            cursor: "pointer",
                                          }}
                                        />

                                        <span
                                          className="text-gray-700"
                                          style={{
                                            fontSize: "14px",
                                            lineHeight: "20px",
                                          }}
                                        >
                                          {e.name}
                                        </span>
                                      </label>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="row">
                            <label className="col-sm-3 col-form-label font-medium text-gray-700">
                              Group
                            </label>
                            <div
                              className="col-sm-9"
                              style={{ display: "flex", gap: "2%" }}
                            >
                              {groups && groups.length > 0 ? (
                                groups.map((g) => (
                                  <label
                                    key={g.group_id}
                                    // className="flex items-center gap-2 mb-1"
                                  >
                                    <input
                                      type="checkbox"
                                      value={g.group_id}
                                      checked={groupId.includes(g.group_id)}
                                      onChange={(e) => {
                                        const id = Number(e.target.value);
                                        let updatedGroups;

                                        if (e.target.checked) {
                                          updatedGroups = [...groupId, id];
                                        } else {
                                          updatedGroups = groupId.filter(
                                            (gid) => gid !== id,
                                          );
                                        }

                                        setGroupId(updatedGroups);

                                        // call your function with the updated group ids
                                        if (updatedGroups.length > 0) {
                                          getCount({
                                            class_ids: [],
                                            theme_ids: quizForm.theme_id
                                              ? selectedSubThemes?.length > 0
                                                ? selectedSubThemes.map(Number)
                                                : [Number(quizForm.theme_id)]
                                              : [],
                                            group_id: updatedGroups,
                                          });
                                        }
                                      }}
                                    />
                                    <span>{g.group_name}</span>
                                  </label>
                                ))
                              ) : (
                                <p>No groups available</p>
                              )}
                            </div>

                            {/* <div className="col-sm-9">
                              <select
                                className="form-control"
                                // name="group_id"
                                value={groupId} // ensure controlled input
                                onChange={(e) => {
                                  setGroupId(e.target.value);
                                  getCount({
                                    class_ids: [],
                                    theme_ids: quizForm.theme_id
                                      ? selectedSubThemes?.length > 0
                                        ? selectedSubThemes.map(Number)
                                        : [Number(quizForm.theme_id)]
                                      : [],
                                    group_id: e.target.value,
                                  });
                                }}
                                // disabled={loading}
                              >
                                <option value="">-- Select Group --</option>
                                {groups && groups?.length > 0 ? (
                                  groups?.map((g) => (
                                    <option key={g.group_id} value={g.group_id}>
                                      {g.group_name}
                                    </option>
                                  ))
                                ) : (
                                  <option disabled>No groups available</option>
                                )}
                              </select>
                            </div> */}
                          </div>
                        </div>
                      )}

                      {quizType === 1 && (
                        <div>
                          <h3
                            style={{
                              textAlign: "center",
                              fontSize: "20px",
                              marginTop: "2%",
                              fontWeight: 545,
                            }}
                          >
                            Question Allotment Form
                          </h3>

                          <div
                            className="form-group"
                            // style={{ display: "flex", gap: "2%" }}
                          >
                            <label
                              className="form-label"
                              style={{ fontWeight: 545 }}
                            >
                              Choose Difficulty Level(s)
                            </label>
                            <select
                              className="form-input"
                              onChange={(e) =>
                                handleAllotmentChange(e.target.value)
                              }
                              value=""
                            >
                              <option value="">Select</option>
                              {["basic", "advanced", "ultra", "docmaster"].map(
                                (level) => (
                                  <option key={level} value={level}>
                                    {level}
                                  </option>
                                ),
                              )}
                            </select>
                          </div>

                          <div style={{ marginTop: "10px" }}>
                            <strong>Total: </strong>
                            <span
                              style={{
                                color: totalAllotment === 100 ? "green" : "red",
                              }}
                            >
                              {totalAllotment}%
                            </span>{" "}
                            (must be exactly 100%)
                          </div>
                          <div
                            style={{
                              marginLeft: "2%",
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "3rem", // reduced gap between boxes
                              marginTop: "1%",
                            }}
                          >
                            {state.allotments.map((each, index) => (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.5rem", // reduced gap inside each box
                                  border: "1px solid #ccc",
                                  padding: "6px 10px", // smaller padding
                                  borderRadius: "6px",
                                  width: "fit-content",
                                  background: "#fafafa",
                                }}
                              >
                                <p
                                  style={{
                                    margin: 0,
                                    fontSize: "0.9rem",
                                    fontWeight: 500,
                                    textTransform: "capitalize",
                                  }}
                                >
                                  {each.difficulty_level}
                                </p>
                                <input
                                  type="number"
                                  style={{
                                    border: "1px solid #bbb",
                                    borderRadius: "4px",
                                    padding: "4px 6px",
                                    width: "60px",
                                    fontSize: "0.9rem",
                                  }}
                                  placeholder="0%"
                                  value={each.percentage}
                                  onChange={(e) => {
                                    const value = Number(e.target.value);
                                    if (value >= 0) {
                                      updatePercent(index, value);
                                    }
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "-" || e.key === "e") {
                                      e.preventDefault();
                                    }
                                  }}
                                  min={0}
                                />
                                <button
                                  type="button"
                                  style={{
                                    background: "transparent",
                                    border: "none",
                                    cursor: "pointer",
                                    padding: 0,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                  title="Remove"
                                  onClick={() =>
                                    removeAllotment(each.difficulty_level)
                                  }
                                >
                                  <img
                                    width="16"
                                    height="16"
                                    src="https://img.icons8.com/ios/50/delete-sign--v1.png"
                                    alt="delete"
                                  />
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </>
                  </>
                )}
                {/* About + Terms */}
                {quizType && subQuizType && (
                  <>
                    {quizType === 1 && (
                      <div>
                        <h4
                          style={{
                            fontSize: "16px",
                            fontWeight: 545,
                            marginTop: "2%",
                          }}
                        >
                          Winner Prize Details
                        </h4>
                        <textarea
                          onChange={(e) =>
                            handleChange("prizeDescription", e.target.value)
                          }
                          value={prizeDescription}
                          className="form-control"
                          placeholder="Enter the winner price details..."
                          required
                        />
                      </div>
                    )}
                    <h3
                      style={{
                        textAlign: "center",
                        fontSize: "20px",
                        fontWeight: 545,
                      }}
                    >
                      Terms and conditions
                    </h3>
                    <div className="form-group">
                      <label className="form-label" style={{ fontWeight: 545 }}>
                        About Quiz
                      </label>
                      <textarea
                        className="form-input"
                        value={quizForm.about}
                        onChange={(e) => handleChange("about", e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label" style={{ fontWeight: 545 }}>
                        Terms and conditions
                      </label>
                      <div style={{ display: "flex", gap: "2%" }}>
                        <textarea
                          className="form-input"
                          style={{ height: "60vh" }}
                          value={quizForm.terms}
                          onChange={(e) =>
                            handleChange("terms", e.target.value)
                          }
                          required
                        />
                      </div>
                    </div>
                    <div
                      className="mt-4 p-3 border rounded bg-gray-50"
                      style={{ height: "30vh", overflow: "auto" }}
                    >
                      <p>
                        <strong>Note:</strong>
                        Please ensure that the following variables are not
                        removed from the Terms and Conditions section above.
                      </p>
                      <p>
                        <strong>
                          Variables used in the Terms and Conditions:
                        </strong>
                        <ol>
                          <li>
                            [Number] – Represents the total number of questions
                            in the quiz.
                          </li>
                          <li>
                            [X seconds] – Represents the total duration of the
                            quiz, calculated as
                            <em>
                              {" "}
                              total questions × duration per question (in
                              seconds)
                            </em>
                            .
                          </li>
                          <li>
                            [X second] – Represents the duration allocated for
                            each question (in seconds).
                          </li>
                          <li>
                            [Correct] – Represents the score awarded for each
                            correct answer.
                          </li>
                        </ol>
                      </p>
                    </div>
                    <div
                      className="mt-4 p-3 border rounded bg-gray-50"
                      style={{ height: "60vh", overflow: "auto" }}
                    >
                      <h4
                        className="mb-2 font-semibold"
                        style={{ textAlign: "center" }}
                      >
                        Preview of Terms and Conditions
                      </h4>
                      {quizType === 2 && (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: formatTerms(quizForm.terms),
                          }}
                        />
                      )}
                      {quizType === 1 && (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: convertTermsToHtml(quizForm.terms),
                          }}
                        />
                      )}
                    </div>
                  </>
                )}
                {quizType && subQuizType && (
                  <div className="text-center mt-4">
                    <button
                      className="btn btn-primary px-4 py-2 rounded"
                      // disabled={!isFormValid}
                      onClick={handleSubmit}
                    >
                      Submit
                    </button>
                  </div>
                )}
              </>
            ) : (
              <p>Please choose a quiz type</p>
            )}
          </div>
          <hr className="my-8 border-gray-300" />
        </div>
      </div>
    </div>
  );
}
